'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const react = require('@emotion/react');
const components_navigation_Button_BaseButton = require('../Button/BaseButton.cjs.js');

function NumberButton(_a) {
  var { selected, value } = _a, buttonProps = tslib_es6.__rest(_a, ["selected", "value"]);
  return react.jsx(components_navigation_Button_BaseButton.BaseButton, Object.assign({}, buttonProps, { color: "number", isSquare: true, isSelected: selected, size: "small" }), value);
}

exports.NumberButton = NumberButton;
//# sourceMappingURL=NumberButton.cjs.js.map
